import { castDraft, immerable, produce } from 'immer';
import { Set } from 'immutable';

import { ColumnStatus } from './subscription.types';

interface IProfileItemEntity {
	id: string;
	label: string;
	description: string;
	columnModelId: string;
	filterModelIds: Set<string>;
	status: ColumnStatus;
	isInSync: boolean;
}

const entityDefaults: IProfileItemEntity = {
	id: '-1',
	label: '',
	description: '',
	columnModelId: '',
	filterModelIds: Set(),
	status: ColumnStatus.None,
	isInSync: false,
};

export class ProfileItemEntity implements IProfileItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public columnModelId = entityDefaults.columnModelId;
	public filterModelIds = entityDefaults.filterModelIds;
	public status = entityDefaults.status;
	public isInSync = entityDefaults.isInSync;

	public static build(
		params: Partial<IProfileItemEntity> = {}
	): ProfileItemEntity {
		const instance = new ProfileItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.columnModelId =
			params.columnModelId ?? entityDefaults.columnModelId;
		instance.filterModelIds =
			params.filterModelIds ?? entityDefaults.filterModelIds;
		instance.status = params.status ?? entityDefaults.status;
		instance.isInSync = params.isInSync ?? entityDefaults.isInSync;

		return instance;
	}

	public setColumnModelId(id: string): ProfileItemEntity {
		return produce(this, (draft) => {
			draft.columnModelId = castDraft(id);
		});
	}

	public setFilterModelIds(ids: Set<string>): ProfileItemEntity {
		return produce(this, (draft) => {
			draft.filterModelIds = castDraft(ids);
		});
	}

	public setMetadata(
		params: Partial<IProfileItemEntity> = {}
	): ProfileItemEntity {
		return produce(this, (draft) => {
			draft.label = castDraft(params.label ?? entityDefaults.label);
			draft.description = castDraft(
				params.description ?? entityDefaults.description
			);
		});
	}

	public isEqualTo(profile: ProfileItemEntity): boolean {
		if (this.label !== profile.label) {
			return false;
		} else if (this.description !== profile.description) {
			return false;
		} else if (this.columnModelId !== profile.columnModelId) {
			return false;
		} else if (!this.filterModelIds.equals(profile.filterModelIds)) {
			return false;
		}

		return true;
	}
}
